export default __webpack_public_path__ + "static/media/wallet.e92cbc39.png";